import { defineComponent } from 'vue'
import { type IRadioInputProps } from './types'
import Button from '../../button'
import { computed } from 'vue'
import type { CSSProperties } from 'vue'
import { Grid } from 'components/grid'

const RadioInput = defineComponent<IRadioInputProps>({
  name: 'RadioInput',
  setup(props) {
    const { asButton, buttonProps, value, variant, label, name, selected } = props

    const selectedStyle = computed((): CSSProperties | string | string[] | CSSProperties[] => {
      return selected
        ? props.selectedStyle || {
          backgroundColor: '#EBF5FF',
          outlineColor: "#3f83f8"
        }
        : props.notSelectedStyle || {}
    })

    return () => {
      return asButton ? (
        <Button
          variant={variant}
          class={[selected ? (props.selectedClass || 'text-primary-500  ') : (props.notSelectedClass || 'hover:bg-primary-100')]}
          style={selectedStyle.value}
          {...(buttonProps || {})}
        >
          {label || name || value}
        </Button>
      ) : (
        <Grid layout="unset" rows="min-content auto" gap="0.5rem">
          <div class='text-gray-900 font-medium text-sm'>{label || name || value}</div>
          <input type="radio" checked={selected} />
        </Grid>
      )
    }
  }
})

RadioInput.props = [
  'value',
  'asButton',
  'buttonProps',
  'variant',
  'name',
  'label',
  'selected',
  'selectedStyle',
  'selectedClass',
  'notSelectedStyle',
  'notSelectedClass'
]

export default RadioInput
